import { vendor } from "../../../es-MX/place/settings/vendor";

export const settings = {
	productsWeb: {
		tabs: {
			personalization: "Personalización de menú",
			banners: "Banners",
			featured: "Destacados",
		},
		personalizationTab: {
			displayTitle: "Visualización",
			displayDescription:
				"Controle qué secciones aparecen para los clientes en los menús digitales.",
			showBanners: "Mostrar banners",
		},
		featuredTab: {
			title: "Sección destacada",
			description:
				"Arme la sugerencia del día del menú digital: elija el título, active la sección y organice los productos destacados en el orden que desee.",
			titleFieldLabel: "Título de la sección",
			titleFieldPlaceholder: "Ej.: Sugerencias del día",
			activeLabel: "Sección activa",
			activeDescription:
				"Cuando está activa, la sección destacada aparece en el menú digital.",
			productsFieldLabel: "Productos destacados",
			productsFieldDescription:
				"Añada productos y arrástrelos para definir el orden de visualización.",
			productsPlaceholder: "Buscar y añadir productos",
			emptySelection: "Aún no hay productos destacados. Añada productos arriba.",
			reorderProduct: "Reordenar producto",
			removeProduct: "Quitar producto",
			save: "Guardar cambios",
			saving: "Guardando...",
			toastSuccess: "Sección destacada guardada con éxito",
			toastError: "No fue posible guardar la sección destacada. Intente nuevamente.",
			noMenuTitle: "No se encontró ningún menú digital",
			noMenuDescription: "Cree un menú digital para configurar la sección destacada.",
			languages: {
				ptBR: "Portugués",
				enUs: "Inglés",
				esMx: "Español",
			},
		},
		bannersTab: {
			title: "Banners de campaña",
			description:
				"Cree y organice los banners que se muestran en la parte superior y entre las secciones del menú digital. Arrastre para reordenar.",
			addBanner: "Añadir banner",
			empty: {
				title: "Ningún banner creado",
				description:
					"Cree banners de campaña para destacar promociones y novedades en el menú digital.",
				action: "Añadir banner",
			},
			slots: {
				hero: "Parte superior (destacado)",
				between_sections: "Entre secciones",
			},
			status: {
				active: "Activo",
				inactive: "Inactivo",
			},
			card: {
				noTitle: "Sin título",
				edit: "Editar banner",
				delete: "Eliminar banner",
				dragHint: "Arrastre para reordenar",
			},
			form: {
				createTitle: "Añadir banner",
				editTitle: "Editar banner",
				image: "Imagen",
				imageHint: "Recomendamos 1280x720 (proporción 16:9), en formatos .PNG o .JPEG.",
				imageRequired: "La imagen es obligatoria.",
				title: "Título",
				titlePlaceholder: "Ej.: Combo de verano",
				subtitle: "Subtítulo",
				subtitlePlaceholder: "Ej.: Pide ya y disfruta",
				linkUrl: "Enlace",
				linkUrlPlaceholder: "https://...",
				slot: "Posición",
				slotHero: "Parte superior (destacado)",
				slotBetweenSections: "Entre secciones",
				targetType: "Direccionamiento",
				targetNone: "Ninguno",
				targetProduct: "Producto",
				targetCategory: "Categoría",
				targetProductPlaceholder: "Seleccione el producto",
				targetCategoryPlaceholder: "Seleccione la categoría",
				startsAt: "Inicio",
				endsAt: "Fin",
				isActive: "Banner activo",
				cancel: "Cancelar",
				save: "Guardar",
				create: "Añadir",
			},
			delete: {
				title: "Eliminar banner",
				descriptionPrefix: "¿Está seguro de que desea eliminar el banner ",
				descriptionSuffix: "? Esta acción no se puede deshacer.",
				fallbackName: "sin título",
				cancel: "Cancelar",
				confirm: "Eliminar",
			},
			toast: {
				createSuccess: "Banner creado con éxito",
				editSuccess: "Banner actualizado con éxito",
				deleteSuccess: "Banner eliminado con éxito",
				reorderSuccess: "Orden de los banners actualizado",
				error: "No fue posible completar la acción. Intente nuevamente.",
			},
		},
	},
	authKeysFeature: {
		phone: "Teléfono",
		email: "Correo electrónico",
		keySelectLabel: "Elija el tipo de clave",
		addKey: "Agregar Claves de autenticación",
		contactsInputLabel: "Agregue una o más claves para autenticación",
		contactsEmailInputPlaceholder: "Ingrese un correo válido (ej: correo@gmail.com)",
		contactsPhoneInputPlaceholder:
			"Ingrese un número de teléfono (ej: +55 (00) 0 00000000",
		btnAddKey: "Agregar claves de autenticación",
		btnCancelAddKey: "Cancelar",
		authKeyAreaTitle: "Autenticación de retiro",
		authKeyAreaSubtitle:
			"Registre claves (correo electrónico o teléfono) que se utilizarán para recibir el código de autenticación al solicitar un retiro.",
		selectContactKeyMessage: "Seleccione un tipo de claves",
		selectContactInputMessage: "Complete una clave de contacto",
		contactAlreadyExists: "¡Este contacto ya existe!",
		invalidEmail: "Correo electrónico inválido",
		invalidPhone: "Teléfono inválido. Debe contener DDI (ej: +5511999999999)",
		incompletePhone: "Número de teléfono incompleto. Ingrese todos los dígitos.",
		invalidDDI:
			"Solo se aceptan números telefónicos brasileños. Use el DDI +55 o déjelo en blanco.",
		errorCreatingAuthKeys: "Error al crear claves de autenticación",
		invalidContactsFound:
			"Se encontraron contactos inválidos. Verifique los datos e intente nuevamente.",
		errorCreatingSomeKeys: "Error al crear algunas claves: {{errors}}",
	},
	vendor,
};
